import { Globe } from '@/components/animations/Globe'
import { DEFAULT_FREE_CREDITS } from '@/features/billing/plans'

export function InfrastructureSection() {
  return (
    <section className="py-24 sm:py-32 border-y border-line relative overflow-hidden bg-surface">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-surface via-ground to-ground opacity-50" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-2 gap-16 items-center">
        <div className="order-2 lg:order-1 relative">
          <div className="absolute inset-0 bg-primary/5 blur-3xl -z-10 rounded-full" />
          <Globe className="scale-110 lg:scale-125" />
        </div>
        <div className="order-1 lg:order-2">
          <h2 className="text-3xl sm:text-4xl font-semibold text-ink tracking-tight">
            Connect your global infrastructure securely.
          </h2>
          <p className="mt-4 text-lg text-ink-muted leading-relaxed">
            Connect GitHub to your AI workflow through a controlled MCP layer. Every tool call is authenticated, logged and governed.
          </p>
          
          <ol className="mt-10 grid gap-8">
            {[
              ['Create an account', `Takes a minute. You start with ${DEFAULT_FREE_CREDITS} free credits.`],
              ['Connect your GitHub', 'You authorise it yourself; your token is stored encrypted and never shown.'],
              ['Ask it something', 'Start with "what changed this week?" or point it at a pull request.'],
            ].map(([title, body], index) => (
              <li key={title} className="flex gap-5 group">
                <div className="flex-none flex items-center justify-center w-10 h-10 rounded-full bg-raised text-sm font-semibold text-ink border border-line group-hover:border-primary transition-colors">
                  {index + 1}
                </div>
                <div>
                  <h3 className="text-base font-semibold text-ink group-hover:text-primary transition-colors">{title}</h3>
                  <p className="mt-1 text-sm text-ink-muted leading-relaxed">{body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  )
}
